

















































































import Vue from 'vue';
import negara from '@/const/country.json';
import { mapState } from 'vuex';
// eslint-disable-next-line no-unused-vars
import { delegatesType, motionsType } from '@/types/api';

export default Vue.extend({
  name: 'Motions',
  data() {
    return {
      motionsData: [] as motionsType.getMotions[],
      delegatesData: [] as delegatesType.getAllDelegates[],
      expand: null as null | string,
    };
  },
  props: {
    confData: Object,
  },
  computed: {
    ...mapState({
      width: (state: any) => state.Global.widthWindow,
    }),
  },
  methods: {
    sortMotions(items: motionsType.getMotions[]): motionsType.getMotions[] {
      items.sort((a, b) => {
        if (a.type.toLowerCase() === 'unmoderated caucus' && b.type.toLowerCase() !== 'unmoderated caucus') {
          return -1;
        }
        if (a.type.toLowerCase() !== 'unmoderated caucus' && b.type.toLowerCase() === 'unmoderated caucus') {
          return 1;
        }
        if (a.type.toLowerCase() === 'consultation of the whole' && b.type.toLowerCase() !== 'consultation of the whole') {
          return -1;
        }
        if (a.type.toLowerCase() !== 'consultation of the whole' && b.type.toLowerCase() === 'consultation of the whole') {
          return 1;
        }
        if (a.type.toLowerCase() === 'moderated caucus' && b.type.toLowerCase() !== 'moderated caucus') {
          return -1;
        }
        if (a.type.toLowerCase() !== 'moderated caucus' && b.type.toLowerCase() === 'moderated caucus') {
          return 1;
        }
        if (a.type === b.type && b.type && a.total_time > b.total_time) {
          return -1;
        }
        if (a.type === b.type && b.type && a.total_time > b.total_time) {
          return 1;
        }
        return 0;
      });
      return items;
    },
    getDelegatesID(name: string): string {
      const data = negara.find((obj) => obj.name === name);
      if (data) return data['alpha-2'];
      return 'ad';
    },
  },
  created() {
    // this.confData.motions.batches;
    this.confData.motions.batches.forEach((motionBatch) => {
      const sorted: motionsType.getMotions[] = this.sortMotions(motionBatch.batch_motions);
      const passed = sorted.findIndex((motion) => motion.yes_vote > motion.no_vote);
      // @ts-ignore
      sorted[passed].passed = true;
      // @ts-ignore
      sorted[sorted.length - 1].last = true;
      this.motionsData.push(...sorted);
    });
  },
});
